import { createStore } from "@xstate/store";

export type CommandView = "home" | "patient-search" | "chat-history" | "colleague-search";

interface PaletteContext {
  open: boolean;
  view: CommandView;
}

export const paletteStore = createStore({
  context: { open: false, view: "home" } as PaletteContext,
  on: {
    "palette.open": (_ctx, event: { view?: CommandView }) => ({
      open: true,
      view: event.view ?? "home",
    }),
    "palette.close": () => ({ open: false, view: "home" as CommandView }),
    "palette.setView": (ctx, event: { view: CommandView }) => ({
      ...ctx,
      view: event.view,
    }),
  },
});
